(function () {
  'use strict';

  const statusTimers = new WeakMap();

  class CartUI {
    static formatMoney(cents) {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(Number(cents || 0) / 100);
    }

    static escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    static dispatchUpdated(cart, source) {
      window.CartApi.dispatchUpdated(cart, source || 'cart');
    }

    static setBusy(element, busy, options) {
      if (!element) return;

      const settings = options || {};
      const className = settings.className || 'is-loading';

      element.classList.toggle(className, busy);
      element.setAttribute('aria-busy', String(busy));

      if (settings.controlsSelector) {
        element
          .querySelectorAll(settings.controlsSelector)
          .forEach(function (control) {
            control.disabled = busy;
          });
      }

      if (settings.loadingSelector) {
        const loading = element.querySelector(
          settings.loadingSelector
        );

        if (loading) {
          loading.hidden = !busy;
        }
      }
    }

    static setStatus(element, message, clearAfter) {
      if (!element) return;

      const existingTimer = statusTimers.get(element);

      if (existingTimer) {
        window.clearTimeout(existingTimer);
        statusTimers.delete(element);
      }

      element.textContent = message || '';

      if (!message || !clearAfter) return;

      const timer = window.setTimeout(function () {
        element.textContent = '';
        statusTimers.delete(element);
      }, clearAfter);

      statusTimers.set(element, timer);
    }
  }

  window.CartUI = CartUI;
})();
